import { render } from "./MainHalfTitle.vue?vue&type=template&id=681ffe88&scoped=true"
import script from "./MainHalfTitle.vue?vue&type=script&lang=js"
export * from "./MainHalfTitle.vue?vue&type=script&lang=js"

import "./MainHalfTitle.vue?vue&type=style&index=0&id=681ffe88&scoped=true&lang=css"

import exportComponent from "D:\\eazyc\\ezDev\\ECS-Cognitive\\cognitive-screening-mobile-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-681ffe88"]])

export default __exports__